import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({ standalone: false,
  selector: 'information-dialog',
  templateUrl: 'information-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['information-dialog.component.scss']
})
export class InformationDialogComponent {
  title: string= "";
  message: string = "";
  confirmButtonText = "OK";
  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<InformationDialogComponent>) {
    if(data){
        this.title=data.title;
        this.message = data.message || this.message;
        if (data.buttonText) {
            this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
        }
    }
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
  onCancelClick(): void {
    this.dialogRef.close(false);
  }

}